export default __webpack_public_path__ + "static/media/ten.1332c641.jpeg";